import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { ApiClientItem } from './components'
import '@boulevard/blvd-ui/index.css'
import './App.scss'
import { FbeAuth, Integrations } from './pages'

function App() {
  return (
    <div className="App">
      <ApiClientItem />
      <header></header>
      <main>
        <div className="container">
          <BrowserRouter>
            <Switch>
              <Route path="/integrations" component={Integrations}/>
              <Route path="/fbe-auth/error" component={FbeAuth}/>
              <Redirect from="/*" to="/integrations" strict exact/>
            </Switch>
          </BrowserRouter>
        </div>
      </main>
    </div>
  )
}

export default App
